"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ReactDOM = require("react-dom");
/**
 * @returns the measured width of a component or element, rounded up to the nearest integer.
 * Returns -1 if the provided node is null, unmounted, or text.
 */
function measureWidth(componentOrElement) {
    try {
        var domNode = ReactDOM.findDOMNode(componentOrElement);
        if (!domNode || typeof domNode == 'string') {
            return -1;
        }
        var rect = domNode.getBoundingClientRect();
        return Math.ceil(rect.right - rect.left);
    }
    catch (e) {
        return -1;
    }
}
exports.measureWidth = measureWidth;
function measureScrollbarWidth(div) {
    var value = div.style.overflowY;
    div.style.overflowY = 'scroll';
    var scrollbarWidth = div.offsetWidth - div.clientWidth;
    div.style.overflowY = value;
    return scrollbarWidth;
}
exports.measureScrollbarWidth = measureScrollbarWidth;
function assert(condition, message) {
    if (!condition) {
        throw new Error(message);
    }
}
exports.assert = assert;
/**
 * Returns value bound within [min, max]
 */
function clamp(value, min, max) {
    if (value < min) {
        return min;
    }
    if (value > max) {
        return max;
    }
    return value;
}
exports.clamp = clamp;
var isMac = /Mac/.test(navigator.userAgent);
/**
 * Platform-aware version of `e.ctrlKey`
 */
function isCtrl(event) {
    if (isMac) {
        return event.metaKey || event.ctrlKey;
    }
    else {
        return event.ctrlKey;
    }
}
exports.isCtrl = isCtrl;
function isFocusable(element) {
    if (!element) {
        return false;
    }
    return !isNaN(parseInt(element.getAttribute('tabindex'), 10)) ||
        ['INPUT', 'SELECT', 'TEXTAREA', 'BUTTON'].indexOf(element.tagName) >= 0 ||
        (element.tagName === 'A' && !!element.getAttribute('href'));
}
exports.isFocusable = isFocusable;
//# sourceMappingURL=Utils.js.map